var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-composer"},[(_vm.showSubject)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subject),expression:"subject"}],staticClass:"message-subject",attrs:{"type":"text","required":"","placeholder":"Enter subject here"},domProps:{"value":(_vm.subject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.subject=$event.target.value}}})]):_vm._e(),_c('PostEditor',_vm._b({ref:"postEditor"},'PostEditor',{
        content: null,
        cancel: this.cancel,
        submit: this.submit,
        allowAttachments: true,
        allowEditReason: false,
        allowMentions: false
    },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }